/*
 * @Author: zhushitao
 * @Date: 2021-07-06 20:35:21
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-11-12 19:13:54
 * @Description:
 */
import { inject, observer, Provider } from 'mobx-react';
import React, { useEffect } from 'react';

import { AppContextType } from '@byted-cg/linkchat-plugin';

import Layout from './Layout';

interface ILocalContext {
  appContext: AppContextType;
  getRemoteComponent: (
    config: any,
  ) => Promise<{ default: React.ComponentType<any> }>;
}
export const LocalProvider = React.createContext<ILocalContext>(
  {} as ILocalContext,
);

export interface IChatPro {
  onUnmount?: () => void;
  appContext: AppContextType;
  style?: React.CSSProperties;
  className?: string;
}

const ChatPro: React.FC<IChatPro> = ({ onUnmount, appContext, ...props }) => {
  useEffect(() => {
    return () => {
      onUnmount && onUnmount();
    };
  }, []);
  const getRemoteComponent = async (componentConfig: IComponent) => {
    try {
      const RemoteComponent = await appContext.libraray?.getComponent(
        componentConfig,
      );

      return {
        default: inject<{
          appContext: AppContextType;
        }>(({ appContext }) => ({
          appContext,
        }))(observer(RemoteComponent as any)),
      };
    } catch (error) {
      appContext.logger?.error(
        `getRemoteComponentError_${componentConfig.code}`,
        {
          error: error,
        },
      );
      throw error;
    }
  };

  return (
    <LocalProvider.Provider
      value={{
        appContext: appContext,
        getRemoteComponent: getRemoteComponent,
      }}
    >
      <Provider appContext={appContext}>
        <Layout {...props} />
      </Provider>
    </LocalProvider.Provider>
  );
};

export default ChatPro;
